import { combineReducers } from 'redux';

import byId from './byId/reducer';

export default combineReducers({
  byId
});



/** WEBPACK FOOTER **
 ** ./src/members/state/topics/reducer.js
 **/